<template>
    <v-dialog v-model="open" max-width="720" :persistent="saving">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" class="mb-4 mr-2" v-bind="attrs" v-on="on" data-test="steffi-open-offline-contract">
                Vertragsset wurde offline angenommen
            </v-btn>
        </template>
        <v-card>
            <v-card-title>Vertragsset wurde offline angenommen</v-card-title>
            <v-card-text>
                <v-alert v-if="error" type="error" outlined dense>{{ error }}</v-alert>
                <v-text-field
                    v-model="search"
                    label="Apotheke suchen"
                    maxlength="100"
                    hint="Mindestens 2 Zeichen: Name, Kundennummer, Postleitzahl oder Ort"
                    persistent-hint
                    :disabled="loading || saving"
                    data-test="steffi-contract-search"
                    @keyup.enter="findPharmacies"
                />
                <v-btn
                    outlined
                    :disabled="search.trim().length < 2 || loading || saving"
                    :loading="loading"
                    data-test="steffi-contract-search-submit"
                    @click="findPharmacies"
                >Suchen</v-btn>
                <template v-if="items">
                    <p v-if="!items.length && !loading" class="mt-4">Keine Apotheken gefunden.</p>
                    <v-radio-group v-model="selected" :disabled="loading || saving">
                        <v-radio v-for="item in items" :key="item.pharmacy_id" :value="item">
                            <template v-slot:label>
                                <div>
                                    <strong>{{ item.name }}</strong>
                                    <div>{{ item.customer_id || item.pharmacy_id }} · {{ item.zip }} {{ item.city }}</div>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </template>
                <template v-if="selected">
                    <v-select
                        v-model="form.plan_code"
                        :items="planItems"
                        dense
                        outlined
                        label="Paket"
                        data-test="steffi-contract-plan"
                    />
                    <v-text-field
                        v-model="form.accepted_at"
                        dense
                        outlined
                        type="date"
                        label="Vertrags-/Annahmedatum"
                        data-test="steffi-contract-date"
                    />
                    <v-checkbox
                        v-model="form.trial_requested"
                        dense
                        label="Mit kostenloser 14-tägiger Testphase starten"
                        data-test="steffi-contract-trial"
                    />
                    <v-checkbox
                        v-model="form.accepted_contract_terms"
                        dense
                        label="Das Vertragsset einschließlich Nutzungsbedingungen, Preisen, AVV/Datenschutz und Abrechnung wurde angenommen."
                        data-test="steffi-contract-accepted"
                    />
                    <v-textarea
                        v-model="form.internal_note"
                        dense
                        outlined
                        auto-grow
                        rows="2"
                        label="Interne Notiz"
                        data-test="steffi-contract-note"
                    />
                </template>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text :disabled="saving" @click="open = false">Schließen</v-btn>
                <v-btn
                    color="primary"
                    :disabled="!canSave"
                    :loading="saving"
                    data-test="steffi-contract-save"
                    @click="save"
                >Steffi hinzufügen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    data: () => ({
        open: false,
        search: '',
        items: null,
        selected: null,
        loading: false,
        saving: false,
        error: '',
        form: {
            plan_code: 'base',
            accepted_at: new Date().toISOString().slice(0, 10),
            trial_requested: false,
            accepted_contract_terms: false,
            internal_note: '',
        },
        planItems: [
            { text: 'Basis', value: 'base' },
            { text: 'Premium', value: 'premium' },
        ],
    }),
    computed: {
        canSave() {
            return Boolean(
                this.selected
                && this.form.plan_code
                && this.form.accepted_at
                && this.form.accepted_contract_terms
                && !this.loading
                && !this.saving,
            );
        },
    },
    methods: {
        async findPharmacies() {
            if (this.search.trim().length < 2 || this.loading || this.saving) return;
            this.loading = true;
            this.error = '';
            this.selected = null;
            this.items = null;
            try {
                const response = await axios.get('/api/steffi/customers', {
                    params: { view: 'onboarding', search: this.search.trim() },
                });
                this.items = response.data.items;
            } catch (error) {
                this.error = error?.response?.data?.message || 'Apotheken konnten nicht geladen werden.';
            } finally {
                this.loading = false;
            }
        },
        async save() {
            if (!this.canSave) return;
            this.saving = true;
            this.error = '';
            try {
                await axios.post(`/api/pharmacies/${this.selected.pharmacy_id}/steffi/admin-booking`, {
                    ...this.form,
                    source: 'steffi_team_offline_contract',
                });
                this.open = false;
                this.$emit('saved');
            } catch (error) {
                this.error = error?.response?.data?.message || 'Steffi Onboarding konnte nicht angelegt werden.';
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
